module.exports={
	"Form": "PhysicalAssetElementTypeViewManifest",
	"Scope": "PhysicalAssetElementType-View",
	"Descriptors":
	{
		"PhysicalAssetElementTypeDetails.Code":
		{
			"Name": "Code",
			"Hash": "PhysicalAssetElementType-View-Code",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.SectionCode":
		{
			"Name": "Section Code",
			"Hash": "PhysicalAssetElementType-View-SectionCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Name":
		{
			"Name": "Name",
			"Hash": "PhysicalAssetElementType-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 6,
				"Section": "PhysicalAssetElementType-View-Identity",
				"Group": "PhysicalAssetElementType-View-Identity"
			}
		},
		"PhysicalAssetElementTypeDetails.Section":
		{
			"Name": "Section",
			"Hash": "PhysicalAssetElementType-View-Section",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Unit":
		{
			"Name": "Unit",
			"Hash": "PhysicalAssetElementType-View-Unit",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.Clarification":
		{
			"Name": "Clarification",
			"Hash": "PhysicalAssetElementType-View-Clarification",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details"
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetMaterial":
		{
			"Name": "Physical Asset Material",
			"Hash": "PhysicalAssetElementType-View-IDPhysicalAssetMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-Details",
				"Group": "PhysicalAssetElementType-View-Details",
				"Entity": "PhysicalAssetMaterial",
				"SearchFields":
				[
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"PhysicalAssetElementTypeDetails.IDPhysicalAssetElementType":
		{
			"Name": "IDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-View-IDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.GUIDPhysicalAssetElementType":
		{
			"Name": "GUIDPhysical Asset Element Type",
			"Hash": "PhysicalAssetElementType-View-GUIDPhysicalAssetElementType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "PhysicalAssetElementType-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "5",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "PhysicalAssetElementType-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "PhysicalAssetElementType-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		},
		"PhysicalAssetElementTypeDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "PhysicalAssetElementType-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "PhysicalAssetElementType-View-DataAudit",
				"Group": "PhysicalAssetElementType-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "PhysicalAssetElementType-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "PhysicalAssetElementType-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "PhysicalAssetElementType-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "PhysicalAssetElementType-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "PhysicalAssetElementType-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "PhysicalAssetElementType-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
